import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/paceed_email_template_bg.png'
import _imports_1 from '../assets/images/logo-fill.png'


const _withScopeId = n => (_pushScopeId("data-v-518a01a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "email-tlp",
  style: {"display":"none"}
}, null, -1))
const _hoisted_2 = { class: "footer-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "footer-logo",
  src: _imports_1,
  alt: "footer-logo"
}, null, -1))
const _hoisted_4 = { class: "footer-link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footerLinkList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "footer-link-item",
            key: index
          }, [
            _createVNode(_component_router_link, {
              to: item.linkPath
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.linkName), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]))
        }), 128))
      ])
    ])
  ], 64))
}